import { FullWidthPage } from "@wayflyer/flyui";
import { useIntl } from "react-intl";
import { useSuspenseQuery } from "@tanstack/react-query";
import { useCustomerAppConfig } from "undercarriage";

import { getFundingApplicationStagesQueryOptions } from "../../queries/funding-application-configuration/queries";

import { buildConnectionsSubtitle } from "./build-connections-subtitle";
import { MESSAGES } from "./message-definitions";
import { SelectPlatformsNext } from "./select-platforms-next/select-platforms-next";

export const SelectPlatformsPage = () => {
  const intl = useIntl();
  const {
    data: { customerDomain },
  } = useCustomerAppConfig();

  const { data: fundingApplicationStages } = useSuspenseQuery(getFundingApplicationStagesQueryOptions(customerDomain));

  return (
    <FullWidthPage
      constrainWidth
      title={intl.formatMessage(MESSAGES.connectionsAndDataHeading)}
      subtitle={buildConnectionsSubtitle(fundingApplicationStages, intl)}
    >
      <SelectPlatformsNext fundingApplicationStages={fundingApplicationStages} />
    </FullWidthPage>
  );
};
